import { Button } from 'antd';
import styles from './index.module.less';
import { useTranslation } from 'react-i18next';

export default function ResultTop({
  totalResults,
  isLocked,
  onExportClick,
}: {
  totalResults: number;
  isLocked: boolean;
  onExportClick: () => void;
}) {
  const { t } = useTranslation();

  return (
    <div className={styles.resultTopContainer}>
      <div className={styles.resultsText}>
        <span>{isLocked ? '🔐***' : totalResults}</span> {t('Results Found')}
      </div>
      <Button type="primary" className={styles.exportButton} icon={<ExportIcon />} onClick={onExportClick}>
        {t('Export')}
      </Button>
    </div>
  );
}

export function ExportIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 10V12.667C14 13.0205 13.8596 13.3596 13.6096 13.6096C13.3596 13.8596 13.0205 14 12.667 14H3.333C2.97947 14 2.64041 13.8596 2.39043 13.6096C2.14044 13.3596 2 13.0205 2 12.667V10M11.333 5.333L8 2M8 2L4.667 5.333M8 2V10"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
